var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Head',{attrs:{"msg":"Welcome to Your Vue.js App"}}),_c('div',[_vm._v("会员中心")]),_c('Footer',{attrs:{"msg":"Welcome to Your Vue.js App"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }